import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';
import constants from './constants';


const superagent = superagentPromise(_superagent, global.Promise);

const API_ROOT = constants.API_ROOT;
const SNIPPET_API_ROOT = constants.SNIPPET_API_ROOT;

//const encode = encodeURIComponent;

const handleErrors = (err, res) => {
  if (err && err.response && err.response.status === 401) {

  }
  return err;
};

const errorHandler = (err, res) => {
  if (err && err.response && err.response.status === 401) {

  }
  let error = {
    error: err,
    response: res
  }
  return error;
};

const responseBody = res => res.body;
const responseText = res => res.text;
const responseFull = res => res;

const tokenPlugin = req => {

};

const ipToken = req => {

  req.set('Authorization', `Bearer 668eb087aa2ddc`);

};


const requests = {
  del: (url, body) =>
    superagent
      .del(`${API_ROOT}${url}`)
      .send(body)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  get: url =>
    superagent
      .get(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  getIpDetails: url =>
    superagent
      .get(`https://ipinfo.io/json`)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  getFull: url =>
    superagent
      .get(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseFull),
  put: (url, body) =>
    superagent
      .put(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  post: (url, body) =>
    superagent
      .post(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  postVision: (url, body) =>
    superagent
      .post(`${constants.VISION_ROOT}${url}`, body)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  uploadFile: (url, file) =>
    superagent
      .post(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .accept('application/json')
      .attach('file', file)
      .end(handleErrors)
      .then(responseBody),

};


const Auth = {
  login: (email, password) =>
    requests.post('/user/login', { email, password }),
  logout: () =>
    requests.post('/user/logout'),
};

const Dashboard = {
  getRateLimitingList: (start, end) =>
    requests.get(`/rateLimiting/getList`),
}

const Tickets = {
  searchTickets: (ticketId, pageNo) =>
    requests.get(`/QCError/getList?ticketIdSearch=${ticketId}&pageNo=${pageNo}&limit=15`),
  getPreResolutionBatchList: () =>
    requests.get(`/QCError/getPreResolutionBatchList`),
  getPreResolutionListDetails: (batchId, intent, errorType, pageNo) =>
    requests.get(`/QCError/getPreResolutionListDetails?batchId=${batchId}&intent=${intent}&errorType=${errorType}&pageNo=${pageNo}&limit=3`),
  updateQCAction: (batchId, id, qcComment, qcPreResolutionAction, intent, errorType, pageNo) =>
    requests.put(`/QCError/updateQCAction`, { batchId, id, qcComment, qcPreResolutionAction, intent, errorType, pageNo, limit: 3 }),
  updatePostResolQCAction: (batchId, id, qcPostResolutionAction, intent, errorType, pageNo) =>
    requests.put(`/QCError/updatePostResolQCAction`, { batchId, id, qcPostResolutionAction, intent, errorType, pageNo, limit: 3 }),
  updateEntries: (arr) =>
    requests.put(`/QCError/updateEntries`, { entries: arr }),
  getPostResolutionBatchList: () =>
    requests.get(`/QCError/getPostResolutionBatchList`),
  processBalancePreResol: (batchId, intent, errorType) =>
    requests.post(`/QCError/processBalancePreResol`, { batchId, intent, errorType }),
  processBalancePostResol: (batchId, intent, errorType) =>
    requests.post(`/QCError/processBalancePostResol`, { batchId, intent, errorType }),
  reviseIssueBasket: (id, errorType) =>
    requests.post(`/QCError/updateErrorType`, { id, errorType }),
  getPostResolutionListDetails: (batchId, intent, errorType, pageNo) =>
    requests.get(`/QCError/getPostResolutionListDetails?batchId=${batchId}&intent=${intent}&errorType=${errorType}&pageNo=0`),
}

const File = {
  bulkUpload: (file) =>
    requests.uploadFile(`/uploadBulkTickets`, file),
}

const Stats = {
  getStats: () =>
    requests.get(`/stats/getStats`),
  exportReport: () =>
    requests.post(`/QCError/exportReport`,
      {
        "dateFrom": "2020-09-01",
        "dateTo": "2020-09-27"
      }),
}

const Config = {
  getQcCheckThreshold: () =>
    requests.get(`/configurations/getPreResolLimitList`),
  getQcTestingThreshold: () =>
    requests.get(`/configurations/getPostResolLimitList`),
  getSlaValues: () =>
    requests.get(`/configurations/getSlaSettings`),
  createCheckThreshold: (obj) =>
    requests.post(`/configurations/addPreResolLimitConfig`, obj),
  createTestThreshold: (obj) =>
    requests.post(`/configurations/addPostResolLimitConfig`, obj),
  updateCheckThreshold: (obj) =>
    requests.put(`/configurations/updatePreResolLimitConfig`, obj),
  updateTestThreshold: (obj) =>
    requests.put(`/configurations/updatePostResolLimitConfig`, obj),
  updateSla: (data) =>
    requests.put(`/configurations/updateSlaSettings`, data),
}

const Calendar = {
  bookSlot: (data) =>
    requests.post(`/calendarSetup/bookSlot`, data),
  getAuthURL: () =>
    requests.get(`/calendarSetup/getAuthURL`),
  showFreeSlots: (month, timeZone) =>
    requests.post(`/calendarSetup/showFreeSlots`, { month, timeZone }),
  getLocationInfo: () =>
    requests.getIpDetails(),
}

const Trial = {
  register: (data) =>
    requests.postVision(`/v1/user/register`, data),
  requestOtp: (email) =>
    requests.postVision(`/v1/user/requestOtp?email=${encodeURIComponent(email)}`),
}

export default {
  Auth,
  Dashboard,
  Tickets,
  Config,
  File,
  Stats,
  Calendar,
  Trial
};
